import React from "react";

const DynamicTable = ({ table }) => {
  if (!table || !Array.isArray(table.value) || table.value.length === 0) {
    return (
      <div className="alert alert-warning" role="alert">
        No data available to display.
      </div>
    );
  }

  // Get all keys from the first object and exclude "total_count"
  const columns = Object.keys(table.value[0]).filter(
    (key) => key !== "total_count"
  );

  return (
    <div className="col-12">
      <div className="card h-100">
        <div className="card-body p-24">
          <h6 className="mb-2 text-md mb-0" style={{ color: "#4b5563" }}>
            {table.metric_name || "Dynamic Table"}
          </h6>

          <div className="table-responsive scroll-sm">
            <table className="table bordered-table mb-0">
              <thead
                className="text-white"
                style={{
                  backgroundColor: "#3a80c2",
                }}
              >
                <tr>
                  {columns.map((column) => (
                    <th
                      key={column}
                      className="bg-transparent text-white bg-transparent text-capitalize"
                    >
                      {column.replace(/_/g, " ")}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {table.value.map((row, rowIndex) => (
                  <tr key={row.id || rowIndex}>
                    {columns.map((col) => (
                      <td key={col}>
                        {row[col] !== null && row[col] !== undefined
                          ? row[col]
                          : "-"}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DynamicTable;
